import React, { useState } from 'react';

// Components
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Slide from '@mui/material/Slide';
import MUITextFieldStyle from '../MUIStyles/MUITextFieldStyle';
import CircularProgress from '@mui/material/CircularProgress';

// Queries
import superagent from 'superagent';
import postActualizarDomicilio from '../Queries/postActualizarDomicilio';

// Styles
import styles from './index.module.sass';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

export default function AddressForm({
  setSessionMessage,
  history,
  getOrder,
  orderData,
  device,
  getCookie,
  webservice,
  callback,
  redirect = '',
  t,
}) {
  const { domicilioEnvio = {} } = orderData || {};
  const isFinal = domicilioEnvio?.domicilioClienteFinalSN || '';

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [form, setForm] = useState(domicilioEnvio);
  const [nextRoute, setNextRoute] = useState('');
  const [checked, setChecked] = useState((isFinal === 'S' && true) || false);
  const [arrayColonias, setColonias] = useState([]);
  const [loadingCol, setLoadingCol] = useState(false);

  const screenSize = device?.screenSize || 'desktop';

  const handleChange = (e, type) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleCheck = (event) => {
    setChecked(event.target.checked);
  };

  function handelDialog(action, messaje, route) {
    if (messaje) setAlertText(messaje);
    setOpen(action);
    if (route) setNextRoute(route);
    if (!action && nextRoute) history.push(nextRoute);
    if (callback) callback();
  }

  async function handleSubmit() {
    if (
      form.cp === undefined ||
      form.colonia === undefined ||
      form.municipio === undefined ||
      form.calle === undefined ||
      form.numeroExterior === undefined
    ) {
      setAlertText(t('address:message'));
      setOpen(true);
      return false;
    } else {
      if (
        checked &&
        (form.domicilioClienteFinalNombre === undefined ||
          form.domicilioClienteFinalTelefono === undefined)
      ) {
        setAlertText(t('address:message'));
        setOpen(true);
        return false;
      } else {
        setLoading(true);
        const response = await postActualizarDomicilio({
          jsonBody: {
            usuarioOK: getCookie('usuarioOk'),
            folioPedido: getCookie('folioPedido'),
            estado: '',
            ocurre: '',

            soloPaqueteria: 0,

            colonia: form?.colonia || '',
            paqueteria: form?.paqueteria || '',

            calle: form?.calle || '',
            municipio: form?.municipio || '',
            cp: form?.cp || '',
            numeroExterior: form?.numeroExterior || '',
            numeroInterior: form?.numeroInterior || '',
            entreCalle: form.entreCalle || '',
            yCalle: form?.yCalle || '',
            domicilioClienteFinalSN: (checked && 'S') || 'N',
            domicilioClienteFinalNombre: form?.domicilioClienteFinalNombre || '',
            domicilioClienteFinalTelefono: form?.domicilioClienteFinalTelefono || '',
          },
        });

        const { tipoMensaje = 'error', mensaje = '' } = response;

        setSessionMessage(mensaje);

        if (tipoMensaje === 'error') {
          if (mensaje === '498' || mensaje === '499') return false;
          setLoading(false);
          setAlertText(mensaje);
          setOpen(true);
          return false;
        }
        setLoading(false);
        handelDialog(true, mensaje, redirect);
        return true;
      }
    }
  }

  function verifyCP(e) {
    let cp = e.target.value;
    if (cp.length !== 5) {
      setAlertText('Codigo postal incorrecto');
      setOpen(true);
      return;
    } else {
      setLoadingCol(true);
      superagent
        .get(`${webservice}/getSepomex?cp=${cp}`)
        .set('Content-Type', 'application/json')
        .then((res) => {
          const { body = {} } = res;
          const { mensaje, colonias, municipio } = body;
          if (mensaje === '') {
            let col = [];
            for (let index = 0; index < colonias.length; index++) {
              col.push(colonias[index].colonia);
            }
            setColonias(col);
            form.municipio = municipio;
            setLoadingCol(false);
          } else {
            setAlertText(mensaje);
            setOpen(true);
            setLoadingCol(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setAlertText('Error');
          setOpen(true);
          setLoadingCol(false);
        });
    }
  }

  function restrictChars($event) {
    if ($event.charCode === 0 || /\d/.test(String.fromCharCode($event.charCode))) {
      return true;
    } else {
      $event.preventDefault();
    }
  }

  return (
    <div className={styles.AddressForm}>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handelDialog(false)}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'>
        <DialogContent>
          <div className={styles.dialogContent}>
            <div className={styles.dialogTitle}>Terramar</div>
            {alertText}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handelDialog(false)} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <div className={`${styles.container} ${styles[screenSize]}`}>
        <div className={`${styles.inputContainer} ${styles.size50} ${styles.paddingRight}`}>
          <MUITextFieldStyle
            fullWidth
            id='outlined-cp-input'
            label={t('address:postalCode')}
            type='text'
            name='cp'
            variant='outlined'
            onBlur={(e) => verifyCP(e)}
            maxLength='5'
            value={form.cp || ''}
            onKeyPress={(e) => restrictChars(e)}
            onChange={(e) => handleChange(e)}
          />
        </div>

        <div className={`${styles.inputContainer} ${styles.size50} ${styles.paddingLeft}`}>
          {(loadingCol && (
            <div className={styles.loading}>
              <CircularProgress className={styles.circularProgress} /> <br />
              Buscando colonias
            </div>
          )) || (
            <select
              className={styles.select}
              name='colonia'
              onChange={(e) => handleChange(e)}
              value={form?.colonia || ''}>
              <option value=''>Colonia*</option>
              {arrayColonias.map((val, key) => {
                return (
                  <option key={key} value={val}>
                    {val}
                  </option>
                );
              })}
            </select>
          )}
        </div>

        <div className={`${styles.inputContainer} ${styles.paddingRight}`}>
          <MUITextFieldStyle
            fullWidth
            id='outlined-municipio-input'
            label={t('address:municipality')}
            type='text'
            name='municipio'
            variant='outlined'
            value={form?.municipio || ''}
            onChange={(e) => handleChange(e)}
            disabled
          />
        </div>

        <div className={`${styles.inputContainer} ${styles.paddingLeft}`}>
          <MUITextFieldStyle
            fullWidth
            id='outlined-calle-input'
            label={t('address:street')}
            type='text'
            name='calle'
            variant='outlined'
            value={form?.calle || ''}
            onChange={(e) => handleChange(e)}
          />
        </div>

        <div className={`${styles.inputContainer} ${styles.paddingRight}`}>
          <MUITextFieldStyle
            fullWidth
            id='outlined-numeroExterior-input'
            label={t('address:outdoorNumber')}
            type='text'
            name='numeroExterior'
            variant='outlined'
            value={form?.numeroExterior || ''}
            onChange={(e) => handleChange(e)}
          />
        </div>

        <div className={`${styles.inputContainer} ${styles.paddingLeft}`}>
          <MUITextFieldStyle
            fullWidth
            id='outlined-numeroInterior-input'
            label={t('address:interiorNumber')}
            type='text'
            name='numeroInterior'
            variant='outlined'
            value={form?.numeroInterior || ''}
            onChange={(e) => handleChange(e)}
          />
        </div>

        <div className={`${styles.inputContainer} ${styles.paddingRight}`}>
          <MUITextFieldStyle
            fullWidth
            id='outlined-entreCalle-input'
            label={t('address:betweenTheStreet')}
            type='text'
            name='entreCalle'
            variant='outlined'
            value={form?.entreCalle || ''}
            onChange={(e) => handleChange(e)}
          />
        </div>

        <div className={`${styles.inputContainer} ${styles.paddingLeft}`}>
          <MUITextFieldStyle
            fullWidth
            id='outlined-yCalle-input'
            label={t('address:andTheStreet')}
            type='text'
            name='yCalle'
            variant='outlined'
            value={form?.yCalle || ''}
            onChange={(e) => handleChange(e)}
          />
        </div>

        <div className={styles.checkContainer}>
          <Checkbox checked={checked} onChange={handleCheck} />
          <span>{t('address:finalClient')}</span>
        </div>

        {checked && (
          <>
            <div className={`${styles.inputContainer} ${styles.paddingRight}`}>
              <MUITextFieldStyle
                fullWidth
                id='outlined-domicilioClienteFinalNombre-input'
                label={t('address:finalClientName')}
                type='text'
                name='domicilioClienteFinalNombre'
                variant='outlined'
                value={form?.domicilioClienteFinalNombre || ''}
                onChange={(e) => handleChange(e)}
              />
            </div>

            <div className={`${styles.inputContainer}  ${styles.paddingLeft}`}>
              <MUITextFieldStyle
                fullWidth
                id='outlined-domicilioClienteFinalTelefono-input'
                label={t('address:finalClientPhone')}
                type='number'
                name='domicilioClienteFinalTelefono'
                variant='outlined'
                value={form?.domicilioClienteFinalTelefono || ''}
                onChange={(e) => handleChange(e)}
                inputProps={{ maxLength: 10 }}
              />
            </div>
          </>
        )}
      </div>

      <div className={styles.formFooter}>
        <div className={styles.button}>
          <Button
            type='submit'
            variant='contained'
            size='large'
            color='primary'
            className={(loading && styles.disabled) || styles.actionButton}
            onClick={handleSubmit}
            disabled={loading}>
            {t('address:saveChanges')}
          </Button>
        </div>
      </div>
    </div>
  );
}
